module.exports = __webpack_public_path__ + "3bc91d873a6560f02651d8255b8f83b9.pdf";